const notificationSettingsActions = {
  NOTIFICATION_SETTINGS_UPDATE: 'NOTIFICATION_SETTINGS_UPDATE',
  NOTIFICATION_SETTINGS_PROP_UPDATE: 'NOTIFICATION_SETTINGS_PROP_UPDATE',
  NOTIFICATION_SETTINGS_PROPS_OF_ORG_UPDATE: 'NOTIFICATION_SETTINGS_PROPS_OF_ORG_UPDATE',
  NOTIFICATION_SETTINGS_PROPS_OF_CATEGORY_UPDATE: 'NOTIFICATION_SETTINGS_PROPS_OF_CATEGORY_UPDATE',
  NOTIFICATION_SETTINGS_PROPS_OF_ALL_UPDATE: 'NOTIFICATION_SETTINGS_PROPS_OF_ALL_UPDATE'
};
export default notificationSettingsActions;
